module.exports = __webpack_public_path__ + "media/common/images/badges/active/elektrizujici_vykon-11e02c0df1632ed1375170d3862185d6.svg";